import styled from "styled-components";

export const Modal = styled.div`
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);
`;
export const ModalBg = styled.div`
  z-index: 9;
  width: 100%;
  height: 500%;
  top: 0;
  left: 0;
  position: fixed;
`;
export const ModalContent = styled.div`
  position: relative;
  z-index: 12;
  width: 670px;
  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  padding: 48px 48px;
  margin: auto;

  @media screen and (max-width: 1024px) {
    & {
      padding: 24px;
      width: calc(100% - 24px);
      //max-height: 100%;
      //overflow-y: auto;
      border-radius: 20px;
    }
  }
`;

export const Head = styled.div`
  position: relative;

  & .close {
    position: absolute;
    top: -12px;
    right: 0;
  }

  @media screen and (max-width: 1024px) {
    & > div {
      margin-bottom: 32px;
    }

    & .close {
      width: 26px;
      height: 26px;
      top: 0px;
      right: 0;
    }
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  height: 29px;
  text-align: center;
  letter-spacing: -0.96px;
  
  margin-bottom: 45px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  margin-top: 24px;
`;

export const CloseIcon = (props) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5469 14.0001L27.6797 1.86721C28.1069 1.44005 28.1069 0.747482 27.6797 0.320373C27.2525 -0.106736 26.56 -0.106791 26.1329 0.320373L14 12.4532L1.86721 0.320373C1.44005 -0.106791 0.747482 -0.106791 0.320373 0.320373C-0.106736 0.747537 -0.106791 1.4401 0.320373 1.86721L12.4532 14L0.320373 26.1329C-0.106791 26.56 -0.106791 27.2526 0.320373 27.6797C0.533928 27.8933 0.813873 28 1.09382 28C1.37376 28 1.65365 27.8933 1.86726 27.6797L14 15.5469L26.1328 27.6797C26.3464 27.8933 26.6263 28 26.9063 28C27.1862 28 27.4661 27.8933 27.6797 27.6797C28.1069 27.2525 28.1069 26.56 27.6797 26.1329L15.5469 14.0001Z"
        fill="#979797"
      />
    </svg>
  );
};

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Rows = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 12px;
`;
export const RowTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  color: #4f4f4f;

  &.link {
    text-decoration-line: underline;
    cursor: pointer;
  }

  &.link:hover {
    color: #F12E11;
  }

  &.highlight {
    font-weight: 500;
    font-size: 16px;
    line-height: 45px;
  }

  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;
export const RowValue = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  color: #4f4f4f;

  &.highlight {
    font-weight: 700;
    font-size: 20px;
    line-height: 45px;
  }
  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;
export const NoteValue = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  color: #cc4338;
  margin-top: 12px;
`;
